module.exports = new __parcel__URL__("elephant.f64545b1.svg").toString();